
import React from 'react'
import GoogleSearchMapNew from '../../../../../common/components/google-map-search-new'

export default function LocationComponent({ dropLocations, setDropLocations, quoteData, setSearchedLocation, searchedLocation, handleChange }: any) {

    return (


        <div className="w-full font-bold space-y-4">

            {/* Pickup Section */}
            <div className="w-full">
                <label className="block text-xs font-bold mb-1 ">
                    Pickup Details <span className="text-red-500">*</span>
                </label>
                <GoogleSearchMapNew
                    required
                                                setLocation={setSearchedLocation}
                                                location={searchedLocation}
                                                placeholder="Pickup Address"

                />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="w-full">
                    <label className="block text-xs font-bold mb-1 ">Name <span className="text-red-500">*</span></label>
                    <input
                        type="text"
                        name="pickupName"
                        className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                        onChange={(event: any) => handleChange(event.target.value, 'pickupName')}
                        value={quoteData?.pickupName}
                    />
                </div>
                <div className="w-full">
                    <label className="block text-xs font-bold mb-1 ">Phone Number <span className="text-red-500">*</span></label>
                    <input
                        type="text"
                        maxLength={10}
                        name="pickupPhoneNumber"
                        className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                        onChange={(event: any) => handleChange(event.target.value.replace(/\D/g, ''), 'pickupPhoneNumber')}
                        value={quoteData?.pickupPhoneNumber}
                    />
                </div>
            </div>

            <div className="w-full">
                <label className="block text-xs font-bold mb-1 ">
                    Pickup Address Additional Info
                </label>
                <input
                    type="text"
                    name="startBuilding"
                    className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                    onChange={(event: any) => handleChange(event.target.value, 'startBuilding')}
                    value={quoteData?.startBuilding}
                />
            </div>

            {/* Drop Section */}
            <div className="w-full">
                <label className="block text-xs font-bold mb-1 ">
                    Drop Details <span className="text-red-500">*</span>
                </label>
                <GoogleSearchMapNew
                    required
                    setLocation={setDropLocations}
                    location={dropLocations}
                    placeholder="Drop Address"
                />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="w-full">
                    <label className="block text-xs font-bold mb-1 ">Name <span className="text-red-500">*</span></label>
                    <input
                        type="text"
                        name="dropName"
                        className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                        onChange={(event: any) => handleChange(event.target.value, 'dropName')}
                        value={quoteData?.dropName}
                    />
                </div>
                <div className="w-full">
                    <label className="block text-xs font-bold mb-1 ">Phone Number <span className="text-red-500">*</span></label>
                    <input
                        type="text"
                        maxLength={10}
                        name="dropPhoneNumber"
                        className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                        onChange={(event: any) => handleChange(event.target.value.replace(/\D/g, ''), 'dropPhoneNumber')}
                        value={quoteData?.dropPhoneNumber}
                    />
                </div>
            </div>

            <div className="w-full">
                <label className="block text-xs font-bold mb-1 ">
                    Drop Address Additional Info
                </label>
                <input
                    type="text"
                    name="endBuilding"
                    className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                    onChange={(event: any) => handleChange(event.target.value, 'endBuilding')}
                    value={quoteData?.endBuilding}
                />
            </div>
        </div>






    )
}